import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_ManageYourNFT = _resolveComponent("ManageYourNFT")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_FeaturedNFTArtworks = _resolveComponent("FeaturedNFTArtworks")!
  const _component_TopCreators = _resolveComponent("TopCreators")!
  const _component_CreateNFT = _resolveComponent("CreateNFT")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageTitle, {
        pageTitle: "Marketplace",
        subTitle: "NFT Marketplace"
      }),
      _createVNode(_component_ManageYourNFT),
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-0" }, "Featured NFT Artworks", -1)),
        _createVNode(_component_RouterLink, {
          to: "/nft-marketplace/creators",
          class: "d-flex text-decoration-none"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", null, "Browse All", -1),
            _createElementVNode("i", { class: "ri-arrow-right-s-line fs-15" }, null, -1)
          ]))]),
          _: 1
        })
      ]),
      _createVNode(_component_FeaturedNFTArtworks),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mb-0" }, "Top Creators", -1)),
        _createVNode(_component_RouterLink, {
          to: "/nft-marketplace/creators",
          class: "d-flex text-decoration-none"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", null, "Browse All", -1),
            _createElementVNode("i", { class: "ri-arrow-right-s-line fs-15" }, null, -1)
          ]))]),
          _: 1
        })
      ]),
      _createVNode(_component_TopCreators)
    ]),
    _createVNode(_component_CreateNFT)
  ], 64))
}